/**
 * Centralized drag-and-drop item types for the editCourse feature.
 * Used by react-dnd for drag source and drop target matching.
 * 
 * All drag-and-drop components should import from here to ensure
 * consistent type strings across the feature.
 */

export const ItemTypes = {
  // Module drag-and-drop (within page content)
  MODULE: 'MODULE',
  
  // Structure editor drag-and-drop (TOC/outline)
  PAGE: 'STRUCTURE_PAGE',
  SECTION: 'STRUCTURE_SECTION',
};

